
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ReplaceRequestPage() {
  const [formData, setFormData] = useState({
    location: '',
    containerNumber: '',
    notes: '',
    contactPerson: '',
    phone: ''
  });
  const [photo, setPhoto] = useState<File | null>(null);
  const [photoPreview, setPhotoPreview] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setPhoto(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setPhotoPreview(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.location || !formData.containerNumber || !photo) return;

    setIsSubmitting(true);
    
    setTimeout(() => {
      setIsSubmitting(false);
      setShowSuccess(true);
      
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }, 1500);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (showSuccess) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" dir="rtl">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-sm w-full">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-check-line text-blue-500 text-3xl"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">تم إرسال طلب التبديل بنجاح</h2>
          <p className="text-gray-600 mb-4">سيتم التواصل معك قريباً لتنسيق عملية التبديل</p>
          <div className="animate-pulse text-sm text-gray-500">جاري العودة للصفحة الرئيسية...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 fixed w-full top-0 z-10">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center ml-3 hover:bg-white/30 transition-colors"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <div>
            <h1 className="font-bold text-lg">تبديل حاوية ممتلئة</h1>
            <p className="text-sm opacity-90">استبدال الحاوية الممتلئة بأخرى فارغة</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 pb-6 px-4">
        {/* Service Info */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <div className="flex items-center mb-4">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center ml-4">
              <i className="ri-refresh-line text-white text-2xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-gray-800 text-lg">تبديل حاوية ممتلئة</h2>
              <p className="text-gray-600 text-sm">سيتم استبدال الحاوية الممتلئة بأخرى فارغة</p>
            </div>
          </div>
          
          <img 
            src="https://public.readdy.ai/ai/img_res/45d065a1bae15ccf450cac0d21c53d55.jpg"
            alt="خدمة تبديل الحاويات"
            className="w-full h-32 object-cover rounded-lg"
          />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Container Number */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-barcode-line ml-2"></i>
              رقم الحاوية الحالية *
            </label>
            <input
              type="text"
              value={formData.containerNumber}
              onChange={(e) => handleInputChange('containerNumber', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right"
              placeholder="أدخل رقم الحاوية المراد تبديلها"
              required
            />
          </div>

          {/* Photo Upload */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-camera-line ml-2"></i>
              صورة الحاوية الحالية *
            </label>
            
            {!photoPreview ? (
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-camera-line text-gray-400 text-2xl"></i>
                </div>
                <p className="text-gray-600 mb-4">التقط صورة للحاوية الممتلئة</p>
                <label className="bg-blue-500 text-white px-6 py-3 rounded-lg cursor-pointer hover:bg-blue-600 transition-colors inline-flex items-center">
                  <i className="ri-camera-line ml-2"></i>
                  التقاط صورة
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handlePhotoChange}
                    className="hidden"
                    required
                  />
                </label>
              </div>
            ) : (
              <div className="space-y-4">
                <img
                  src={photoPreview}
                  alt="صورة الحاوية"
                  className="w-full h-48 object-cover rounded-lg"
                />
                <button
                  type="button"
                  onClick={() => {
                    setPhoto(null);
                    setPhotoPreview('');
                  }}
                  className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  <i className="ri-delete-bin-line ml-2"></i>
                  حذف الصورة والتقاط أخرى
                </button>
              </div>
            )}
          </div>

          {/* Location */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-map-pin-line ml-2"></i>
              الموقع *
            </label>
            <textarea
              value={formData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right resize-none"
              rows={3}
              placeholder="أدخل العنوان التفصيلي للموقع..."
              required
            />
          </div>

          {/* Contact Person */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-user-line ml-2"></i>
              اسم الشخص المسؤول
            </label>
            <input
              type="text"
              value={formData.contactPerson}
              onChange={(e) => handleInputChange('contactPerson', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right"
              placeholder="اسم الشخص المسؤول عن التبديل"
            />
          </div>

          {/* Notes */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-file-text-line ml-2"></i>
              ملاحظات إضافية
            </label>
            <textarea
              value={formData.notes}
              onChange={(e) => handleInputChange('notes', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right resize-none"
              rows={3}
              placeholder="أي ملاحظات حول حالة الحاوية أو تعليمات خاصة..."
              maxLength={500}
            />
            <div className="text-xs text-gray-500 mt-2 text-right">
              {formData.notes.length}/500
            </div>
          </div>

          {/* Submit Button */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <button
              type="submit"
              disabled={isSubmitting || !formData.location || !formData.containerNumber || !photo}
              className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 rounded-lg font-medium hover:from-orange-600 hover:to-orange-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white ml-2"></div>
                  جاري إرسال الطلب...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-line ml-2"></i>
                  إرسال طلب التبديل
                </>
              )}
            </button>
            
            <div className="mt-3 space-y-1">
              {!formData.location && (
                <p className="text-red-500 text-sm text-center">الموقع مطلوب</p>
              )}
              {!formData.containerNumber && (
                <p className="text-red-500 text-sm text-center">رقم الحاوية مطلوب</p>
              )}
              {!photo && (
                <p className="text-red-500 text-sm text-center">صورة الحاوية مطلوبة</p>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}